import * as t from "io-ts";
import { realOptional } from "./optional";
export const driversTimeSheetExportReqT = t.strict({
    driver: realOptional(t.string),
    startDate: t.string,
    endDate: t.string,
    separateFiles: t.boolean,
});
//# sourceMappingURL=drivers-timesheet-export.js.map